import {useCallback} from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import {useDispatch} from 'react-redux';

import routeByName from '~/constants/routes';
import useModalById from '~/customHooks/useModalById';
import {MODAL_VERIFY_PROFILE} from '~/rootStore/modals/modalsIds';
import {navigateAction} from '~/actions/navigateActions';

import verificationIcon from './img/verify-profile.svg';
import ModalBase from '../ModalBase';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(1),
  },
}));

const ModalVerifyProfile: React.FC = () => {
  const s = useStyles();
  const dispatch = useDispatch();
  const {
    isOpen,
    props: {verifyModalContent: modalContent},
    close: closeVerifyModal,
  } = useModalById(MODAL_VERIFY_PROFILE);
  const handleActionClick = useCallback(() => {
    closeVerifyModal();
    dispatch(navigateAction(routeByName.identityVerification));
  }, [closeVerifyModal, dispatch]);

  return (
    <ModalBase
      open={isOpen}
      onClose={closeVerifyModal}
      showSkipButton
      skipButtonText="Verify Later"
    >
      <div className={s.wrapper}>
        <Box mb={1.5}>
          <img src={verificationIcon} alt="Verify your profile" />
        </Box>
        <Box mb={1.5} textAlign="center">
          <Typography variant="h2">
            {modalContent || 'You need to verify your profile first to buy VIP upgrade'}
          </Typography>
        </Box>
        <Box alignSelf="stretch">
          <Button fullWidth variant="contained" color="secondary" onClick={handleActionClick}>
            Verify Now
          </Button>
        </Box>
      </div>
    </ModalBase>
  );
};

export default ModalVerifyProfile;
